import Typography from '@components/v2/ui/Typography/Typography';
import LangEnum from '../../../../../../../lang/LangEnum';
import {
  GetKitCombination,
  GetKitCombinationCount,
} from '../../../../../../../services/modules/kit/kitDetails/kitDetails.types';
import { useTranslation } from '../../../../../../translation/TranslationContext';
import { KitCombinationTypes } from '../../../../types/kit-combinations.types';
import KitGroupSection from './components/KitGroupSection';

interface KitDetailsSectionHeaderProps {
  combination: GetKitCombination;
  count?: GetKitCombinationCount;
}

const KitDetailsSectionHeader = ({ combination, count }: KitDetailsSectionHeaderProps) => {
  const { type } = combination;
  const { translate } = useTranslation();

  return type === KitCombinationTypes.CLOSED_KIT ? (
    <KitGroupSection combination={combination} count={count} />
  ) : (
    <Typography variant="overline" color="text.primary">
      {translate(LangEnum.KIT_ITEMS_GROUPED_SECTION_HEADER_LABEL)}
    </Typography>
  );
};

export default KitDetailsSectionHeader;
